import React, { createContext, useContext, useState } from "react";

// theme = color of the header content ("dark" = dark logo/menu over light bg,
// "light" = white menu over a dark hero image). Auto-detected by the Hero.
const HeaderThemeContext = createContext(null);

export function HeaderThemeProvider({ children }) {
  const [theme, setTheme] = useState("dark");
  return (
    <HeaderThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </HeaderThemeContext.Provider>
  );
}

export function useHeaderTheme() {
  return useContext(HeaderThemeContext) || { theme: "dark", setTheme: () => {} };
}
